import { render } from "./ProductModels.vue?vue&type=template&id=d003d53a&scoped=true"
import script from "./ProductModels.vue?vue&type=script&lang=js"
export * from "./ProductModels.vue?vue&type=script&lang=js"

import "./ProductModels.vue?vue&type=style&index=0&id=d003d53a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d003d53a"]])

export default __exports__